import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import 'styled-components';
import '../../../theme/GlobalStyle.js';
import 'react-helmet-async';
import 'lodash';
import '../../../theme/ThemedComponentWrapper.js';
import Card from '../../atoms/Card/Card.js';
import '../../icons/ActivityIcon.js';
import '../../icons/ArrowDownIcon.js';
import '../../icons/ArrowDownRightCircleIcon.js';
import '../../icons/ArrowLeftAlignIcon.js';
import '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightAlignIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/ArrowSwitchIcon.js';
import '../../icons/ArrowUpIcon.js';
import '../../icons/ArrowUpRightCircleIcon.js';
import '../../icons/ArrowsAngleExpandIcon.js';
import '../../icons/BankIcon.js';
import '../../icons/CheckIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CopyIcon.js';
import '../../icons/CrossIcon.js';
import '../../icons/DaiIcon.js';
import '../../icons/DangerIcon.js';
import '../../icons/DownSortIcon.js';
import '../../icons/ExclamationTriangleIcon.js';
import '../../icons/ExpandKpiIcon.js';
import '../../icons/EyeIcon.js';
import '../../icons/EyeSlashIcon.js';
import '../../icons/Grid1x2Icon.js';
import '../../icons/InfoCircleIcon.js';
import '../../icons/ListIcon.js';
import '../../icons/LockIcon.js';
import '../../icons/MediumIcon.js';
import '../../icons/MoonIcon.js';
import '../../icons/PiggyBankIcon.js';
import '../../icons/QuestionMarkCircleIcon.js';
import '../../icons/ShieldIcon.js';
import '../../icons/SunIcon.js';
import '../../icons/UpSortIcon.js';
import '../../icons/XIcon.js';
import '../../atoms/Input/Input.js';
import '../../atoms/ToggleSwitch.js';
import '../../atoms/Table/Table.js';
import '../../atoms/Table/components/HeaderCell/HeaderCell.js';
import 'luxon';
import '@floating-ui/react';
import '../../atoms/Tooltip/components/TooltipContext.js';
import '../../atoms/Tooltip/components/TooltipContent.js';
import '../../atoms/Tooltip/components/TooltipTrigger.js';
import '../../atoms/Table/components/Pagination/Pagination.js';
import '../../atoms/layout/Stack/Stack.js';
import '../CurrencyValue/components/Value.js';
import '../../pictograms/EthPictogram.js';
import '../../pictograms/EtherScanPictogram.js';
import '../../pictograms/DebankPictogram.js';
import '../../pictograms/ZapperPictogram.js';
import '../../pictograms/DaiPictogram.js';
import '../TrendValue.js';
import '../KpiCard/KpiCard.js';
import '../Tabs/Tabs.js';
import Skeleton from '../../atoms/Skeleton.js';
import '../../charts/ChartKpis/ChartKpi.js';
import '../../charts/ChartJS.js';
import '../../charts/Heatmap/Heatmap.js';
import 'randomcolor';
import 'd3';
import '../../XRay.js';
import 'ethereum-blockies-base64';

function KpiSkeleton(props) {
    return (jsxs(Card, { gap: "xs", ...props, children: [jsx(Skeleton, { height: "1" }), jsx(Skeleton, { height: "4" })] }));
}

export { KpiSkeleton as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiS3BpU2tlbGV0b24uanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL21vbGVjdWxlcy9za2VsZXRvbnMvS3BpU2tlbGV0b24udHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFNrZWxldG9uLCBDYXJkLCBDYXJkUHJvcHMgfSBmcm9tICdAYXRvbXMnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBLcGlTa2VsZXRvbihwcm9wczogQ2FyZFByb3BzKSB7XG4gIHJldHVybiAoXG4gICAgPENhcmQgZ2FwPVwieHNcIiB7Li4ucHJvcHN9PlxuICAgICAgPFNrZWxldG9uIGhlaWdodD1cIjFcIiAvPlxuICAgICAgPFNrZWxldG9uIGhlaWdodD1cIjRcIiAvPlxuICAgIDwvQ2FyZD5cbiAgKTtcbn1cbiJdLCJuYW1lcyI6WyJfanN4cyIsIl9qc3giXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBRXdCLFNBQUEsV0FBVyxDQUFDLEtBQWdCLEVBQUE7SUFDbEQsUUFDRUEsSUFBQyxDQUFBLElBQUksRUFBQyxFQUFBLEdBQUcsRUFBQyxJQUFJLEVBQUssR0FBQSxLQUFLLEVBQ3RCLFFBQUEsRUFBQSxDQUFBQyxHQUFBLENBQUMsUUFBUSxFQUFBLEVBQUMsTUFBTSxFQUFDLEdBQUcsRUFBQSxDQUFHLEVBQ3ZCQSxHQUFBLENBQUMsUUFBUSxFQUFBLEVBQUMsTUFBTSxFQUFDLEdBQUcsRUFBQSxDQUFHLENBQ2xCLEVBQUEsQ0FBQSxFQUNQO0FBQ0o7Ozs7In0=
